import * as types from "./mutation-types";

export const setShorterTutorial = async ({ commit }, value) => {
  commit(types.SET_SHORTER_TUTORIAL, value);
};
